import { render, staticRenderFns } from "./BoardSectionShow.vue?vue&type=template&id=3f8b1a00&scoped=true&"
import script from "./BoardSectionShow.vue?vue&type=script&lang=ts&"
export * from "./BoardSectionShow.vue?vue&type=script&lang=ts&"
import style0 from "./BoardSectionShow.vue?vue&type=style&index=0&id=3f8b1a00&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8b1a00",
  null
  
)

export default component.exports